import { render, staticRenderFns } from "./VsfPaymentProvider.vue?vue&type=template&id=7c47c8d5&scoped=true"
import script from "./VsfPaymentProvider.vue?vue&type=script&lang=js"
export * from "./VsfPaymentProvider.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./VsfPaymentProvider.vue?vue&type=style&index=0&id=7c47c8d5&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./VsfPaymentProvider.vue?vue&type=style&index=1&id=7c47c8d5&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7c47c8d5",
  "5ebf3276"
  
)

export default component.exports